import * as React from 'react';
import { observer } from 'mobx-react';
import { configurationsStore } from 'utils/MobxDataManager/singletons';
import './emailManagementListRow.scss';
import { INotificationDisabledUser } from 'typings/MobxComponents/notificationDisabledUser';

export interface IEmailManagementListRowProps {
    notificationDisabledUser: INotificationDisabledUser;
    isDisabled: boolean;
}

export class EmailManagementListRow extends React.Component<IEmailManagementListRowProps> {
    constructor(props: IEmailManagementListRowProps) {
        super(props);

        this.handleEnableEmails = this.handleEnableEmails.bind(this);
    }

    render(): React.ReactNode {
        if (!this.props.notificationDisabledUser?.workEmail) {
            return null;
        }

        return (
            <div className="email-management-list-row">
                <div>
                    <div className="email-management-list-row__name">
                        {this.displayName}
                    </div>
                    <div className="email-management-list-row__job-email">
                        {this.detailsRow}
                    </div>
                </div>
                <div className="email-management-list-row__enable-link"/>
                {!this.props.isDisabled && (
                    <button className="pxl-link" onClick={this.handleEnableEmails}>Enable Emails</button>
                )}
                <div/>
            </div>
        );
    }

    private get displayName(): string {
        const { notificationDisabledUser } = this.props;
        const firstName = this.props.notificationDisabledUser.firstName ?? '';
        const lastName = this.props.notificationDisabledUser.lastName ?? '';

        if (firstName && lastName) {
            return `${firstName} ${lastName}`;
        }
        if (firstName) {
            return firstName;
        }
        if (lastName) {
            return lastName;
        }
        return notificationDisabledUser.workEmail ?? '';

    }

    private get detailsRow(): string {
        const { notificationDisabledUser } = this.props;
        const jobTitle = notificationDisabledUser.jobTitle ?? '';
        return jobTitle ?
            `${jobTitle} | ${notificationDisabledUser.workEmail}` :
            notificationDisabledUser.workEmail ?? '';
    }

    private async handleEnableEmails(): Promise<void> {
        const { notificationDisabledUser } = this.props;
        if (notificationDisabledUser.workEmail) {
            await configurationsStore.enableEmailNotification(notificationDisabledUser.workEmail);
        }
    }
}

export default observer(EmailManagementListRow);
